<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div
          :class="size"
          class="modal-container">

          <div class="modal-header">
            <slot name="header">
              default header
            </slot>
            <span
              class="modal-close"
              @click="$emit('close')">
              <i class="far fa-times" />
            </span>
          </div>

          <div class="modal-body text-center font-weight-bold">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              default footer
              <button
                class="modal-default-button"
                @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Modal',
  components: {},
  props: {
    size: {
      type: String,
      default: 'sm',
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  &.sm {
    width: 300px;
    @media screen and (max-width: 300px) {
      width: auto;
      max-width: 100%;
    }
  }
  &.md {
    width: 500px;
    @media screen and (max-width: 500px) {
      width: auto;
      max-width: 100%;
    }
  }
  &.lg {
    width: 600px;
    @media screen and (max-width: 600px) {
      width: auto;
      max-width: 100%;
    }
  }
  margin: 0px auto;
  padding: 20px 30px;
  background-color: $base;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-size: 1.75rem;
}

.modal-body {
  margin: 20px 0;
}

.modal-body {
  @media screen and (max-height: 630px) {
    padding: 0;
  }
}

.modal-default-button {
  float: right;
}

.modal-header {
  position: relative;
}

.modal-close {
  position: absolute;
  right: -10px;
  top: -6px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-footer {
  justify-content: center;
}
</style>
